import React from 'react';
import Image from './Image';
import { Video } from './Video';

const HomepagePhone = () => {
  return (
    <>
      <div className='what-accent-1'>
        <Image
          src='https://images.ctfassets.net/ss5kfr270og3/3rdsesKs5mC5bNKBlUWfAk/cd07dad6bcee7d1f4e13ecebda0e4816/homepage-howitworks-brushstroke-left.png?fm=webp&q=70'
          alt=''
          isLazy={true}
        />
      </div>
      <Image
        className='simple-carousel-phone-img'
        src='/assets/img/phones/screen1.png'
        alt='Plaid Link'
        height='625'
        width='304'
        isLazy={true}
      />

      <Video
        isLazy={true}
        className='phone-video'
        width={267}
        height={578}
        poster='/assets/img/backgrounds/institution-list@2x.jpg'
        formats={[
          {
            src: '/assets/video/how-it-works.webm',
            type: 'video/webm',
          },
          {
            src: '/assets/video/how-it-works.mp4',
            type: 'video/mp4',
          },
        ]}
      />
    </>
  );
};

export default HomepagePhone;
